import React from 'react';

const links = [
  { name: 'Files', href: '/files' },
  { name: 'All Files', href: '/files/all' },
  { name: 'Remote Files', href: '/files/remote' },
];

const typeLinks = [
  { name: 'Local Video', href: '/files?type=video%2Fmp4' },
  { name: 'Local Image', href: '/files?type=image%2Fjpeg' },
  { name: 'Local Audio', href: '/files?type=audio%2Fmp3' },
  { name: 'Local Text', href: '/files?type=text%2Fplain' },
  { name: 'Combined Video', href: '/files/all?type=video%2Fmp4' },
  { name: 'Combined Image', href: '/files/all?type=image%2Fjpeg' },
  { name: 'Combined Audio', href: '/files/all?type=audio%2Fmp3' },
  { name: 'Combined Text', href: '/files/all?type=text%2Fplain' },
];

function AuthenticatedLinks() {
  return (
    <div className='px-4 sm:px-6 lg:px-8'>
      <div className="text-center py-12 bg-white rounded-2xl shadow-sm border border-gray-100 mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">You are logged in</h1>
        <p className="text-gray-600 max-w-lg mx-auto mb-8">
          Access your personal files and browse your file collection.
        </p>
      </div>

      {/* メインページリンクグリッド */}
      <div className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4'>
        {links.map(link => (
          <a
            key={link.href}
            href={link.href}
            className="group relative bg-white rounded-xl shadow-sm border border-gray-100 p-5 hover:shadow-lg hover:border-blue-200 active:scale-[0.98] transition-all duration-200"
          >
            <div className="flex items-center justify-between">
              <span className="text-base sm:text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors min-w-0 truncate">
                {link.name}
              </span>
              <svg
                className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-blue-500 transform group-hover:translate-x-1 transition-all"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </a>
        ))}
      </div>

      {/* タイプ別リンクグリッド - スマホで 2 列、タブレット以上で横長 */}
      <div className='mt-6 grid grid-cols-2 sm:grid-cols-4 gap-3'>
        {typeLinks.map(link => (
          <a
            key={link.href}
            href={link.href}
            className="group bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-3 sm:p-4 hover:shadow-md active:scale-[0.98] transition-all duration-200 border border-blue-100"
          >
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
              <span className="text-sm sm:text-base font-medium text-gray-700 group-hover:text-blue-700 transition-colors min-w-0 truncate">
                {link.name}
              </span>
              <svg
                className="w-3 h-3 sm:w-4 sm:h-4 text-blue-400 group-hover:text-blue-600 self-end sm:self-center transition-all"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

function PublicPage() {
  const isAuthenticated = !!localStorage.getItem('authToken');

  return (
    <div className="min-h-screen bg-gray-50">
      <div className='px-4 sm:px-6 lg:px-8 py-12'>
        {!isAuthenticated ? (
          <div className="text-center max-w-2xl mx-auto">
            <div className="mb-8">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-100 rounded-full mb-6">
                <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14M3 8a6 6 0 0112 0v4a6 6 0 01-12 0" />
                </svg>
              </div>
              <h1 className="text-4xl font-bold text-gray-900 mb-4">Welcome to FileView</h1>
              <p className="text-lg text-gray-600 max-w-xl mx-auto">
                This is a public preview of the application. Log in to access your files and personalize your experience.
              </p>
            </div>

            <a
              href="/login"
              className="inline-flex items-center px-8 py-4 bg-blue-600 text-white rounded-full font-semibold shadow-lg shadow-blue-200 hover:bg-blue-700 transition-all active:scale-95"
            >
              Log In to Continue
              <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>

            <div className="mt-8 text-gray-500">
              <p>Already have an account? <a href="/login" className="text-blue-600 hover:text-blue-700 font-medium">Sign in</a></p>
            </div>
          </div>
        ) : (
          <AuthenticatedLinks />
        )}
      </div>
    </div>
  );
}

export default PublicPage;
